import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=448de71f"
import script from "./ArticleDetail.vue?vue&type=script&lang=ts"
export * from "./ArticleDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports